import React, { useState, useEffect } from 'react';

const ClientPhotoCollection = ({ productId, onPhotoAdded, onPhotoRemoved, canEdit = true }) => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Загрузка фото клиента
  const loadPhotos = async () => {
    try {
      setLoading(true);
      setError(''); // Очищаем ошибки при загрузке
      const token = localStorage.getItem('clientToken');
      const response = await fetch(`https://limitverify.ru:5000/api/client/photos?productId=${productId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка загрузки фото');
      }

      const data = await response.json();
      setPhotos(data.photos || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Добавление фото в коллекцию
  const addPhoto = async (photoUrl, originalPhotoUrl = null) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('clientToken');
      const response = await fetch('/api/client/photos', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          productId: productId,
          photoUrl: photoUrl,
          originalPhotoUrl: originalPhotoUrl,
          displayOrder: photos.length + 1,
          isPrimary: photos.length === 0 // Первое фото делаем основным
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Ошибка добавления фото');
      }

      const data = await response.json();
      setPhotos(prev => [...prev, data.photo]);
      onPhotoAdded && onPhotoAdded(data.photo);
      setError('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Удаление фото из коллекции
  const removePhoto = async (photoId) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('clientToken');
      const response = await fetch(`https://limitverify.ru:5000/api/client/photos/${photoId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Ошибка удаления фото');
      }

      setPhotos(prev => prev.filter(photo => photo.id !== photoId));
      onPhotoRemoved && onPhotoRemoved(photoId);
      setError('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Загружаем фото при монтировании компонента
  useEffect(() => {
    if (productId) {
      loadPhotos();
    }
  }, [productId]);

  // Функция для обновления списка фото
  const refreshPhotos = () => {
    loadPhotos();
  };

  // Передаем функцию обновления родительскому компоненту
  useEffect(() => {
    if (onPhotoAdded) {
      onPhotoAdded(refreshPhotos);
    }
  }, [onPhotoAdded]);

  return (
    <div className="client-photo-collection">
      <h4 style={{ color: '#1a472a', fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>Мои фото изделия</h4>
      
      {error && (
        <div style={{ color: 'red', marginBottom: '10px' }}>
          {error}
        </div>
      )}

      {loading && (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          Загрузка...
        </div>
      )}

      {photos.length === 0 && !loading ? (
        <div style={{ textAlign: 'center', padding: '20px', color: '#1a472a', fontWeight: '500' }}>
          У вас пока нет фото этого изделия в коллекции
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '10px' }}>
          {photos.map(photo => (
            <div key={photo.id} style={{ position: 'relative', border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
              <img 
                src={photo.photoUrl} 
                alt="Фото изделия"
                style={{ width: '100%', height: '120px', objectFit: 'cover' }}
              />
              {photo.isPrimary && (
                <div style={{ 
                  position: 'absolute', 
                  top: '5px', 
                  left: '5px', 
                  background: '#1890ff', 
                  color: 'white', 
                  padding: '2px 6px', 
                  borderRadius: '4px', 
                  fontSize: '10px' 
                }}>
                  ОСНОВНОЕ
                </div>
              )}
              {canEdit && (
                <button
                  onClick={() => removePhoto(photo.id)}
                  style={{
                    position: 'absolute',
                    top: '5px',
                    right: '5px',
                    background: '#8c1913',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '28px',
                    height: '28px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 2px 4px rgba(140, 25, 19, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#a01f1a';
                    e.target.style.transform = 'scale(1.1)';
                    e.target.style.boxShadow = '0 4px 8px rgba(140, 25, 19, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = '#8c1913';
                    e.target.style.transform = 'scale(1)';
                    e.target.style.boxShadow = '0 2px 4px rgba(140, 25, 19, 0.3)';
                  }}
                  title="Удалить из коллекции"
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClientPhotoCollection;
